import React from "react";
import Body from "../components/Body";
import Header from "../components/Header";

const Home = () => {
  return (
    <div className="home">
      <Header />
      <Body />
    </div>
  );
};

export default Home;
